export const isEverphoneEmailAddress = (email: string): boolean =>
  email.includes('@everphone.')
